import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import MangaCard from "@/components/base/MangaCard";

export default function LatestUpdates() {
  const latest = [...mangaList]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 12);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            最近更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最新鲜的漫画章节，第一时间追更</p>
        </div>
        <Link
          to="/category/hanman"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          全部更新 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
        {latest.map((manga) => (
          <MangaCard key={manga.id} {...manga} />
        ))}
      </div>
    </section>
  );
}